import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../GuideDetails.css";
import { scroller } from "react-scroll";
import Footer from "../Footer";


import tourImg1 from "../../assets/private/10.jpg"; 
import tourImg2 from "../../assets/private/7.jpg"; 
import tourImg3 from "../../assets/private/5.jpg"; 
import tourImg4 from "../../assets/private/9.jpg"; 
import tourImg5 from "../../assets/private/11.jpg"; 
import tourImg6 from "../../assets/private/1.jpg"; 
import tourImg7 from "../../assets/private/7 private.jpg"; 
import tourImg8 from "../../assets/private/4.jpg";
import tourImg9 from "../../assets/private/8.jpg"; 
import tourImg10 from "../../assets/private/10 private.jpg"; 
import tourImg11 from "../../assets/private/private.jpg"; 
import tourImg12 from "../../assets/private/private 1.jpg"; 



export default function FreeWalkingTour() {
  const bookingRef = useRef(null);
  const navigate = useNavigate();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Original images array
  const images = [
    tourImg1, tourImg2, tourImg3, tourImg4, tourImg5, tourImg6, 
    tourImg7, tourImg8, tourImg9, tourImg10, tourImg11, tourImg12
   
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Scroll BookingForm to center of viewport
const scrollToBooking = () => {
  if (bookingRef.current) {
    const topOffset = 80; // height of your navbar in px
    const elementPosition = bookingRef.current.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - topOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const prevImage = (e) => {
    e.stopPropagation(); // prevent closing
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="guide-page">

{/* Back Button */}
<button
  className="back-button"
  onClick={() => {
    // Navigate to home first
    navigate("/", { replace: false });

    // Then scroll after a tiny delay
    setTimeout(() => {
      scroller.scrollTo("tours", {
        smooth: true,
        offset: -70, // height of navbar
        duration: 500,
      });
    }, 100);
  }}
>
  ← Back to Tours
</button>

      <div className="guide-container">
        <div className="guide-left">
           <div class="tour-description">
              <h1 class="tour-intro">Private Tour Overview</h1>

              <p style={{fontSize: '20px'}}>
               Enjoy Gjirokaster in a more personal, flexible and immersive way with a guide dedicated entirely to you.
              </p>

            
              <p style={{fontSize: '20px'}}>This tour focuses on the main historical highlights of the old town while allowing space for deeper explanations, discussion, and photo stops.<br></br>
              Perfect for families, groups, or travelers who want a deeper, more tailored experience.
              </p>
          <p style={{ fontSize: '20px' }}>Gjirokaster Free Walking Tour would love your feedback.<br />
            Post a review to our{' '}
            <a
              href="https://g.page/r/CczRozaFUakUEBE/review"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: '#3d5a80' }}
            >
              profile
            </a>
</p>
            <p style={{fontSize: '20px'}}>This private tour can be customized according to your interests as well.<br></br>
If you prefer, instead of the castle, you may choose to visit inside the 300-year-old Skenduli House, a remarkable example of traditional architecture
and pas by the former home of Enver Hoxha, today the Ethnographic Museum</p>
          </div>
        </div>

        <div className="guide-right">
          <div className="guide-modal">
            <h2 className="tour-overview-heading">What we’ll See</h2>
            <ul style={{fontSize: '19px'}}>
              <p style={{textAlign: 'center', fontSize:'20px'}}>On this tour, we explore the key landmarks of the historic center, including: </p>
              <li>Çerçiz Topulli Square</li>
              <li>The Old Bazaar</li>
              <li>The Bazaar Mosque</li>
              <li>The Obelisk Monument</li>
              <li>The Communist Tunnels</li>
              <li>The Castle</li>

            </ul>

            <h3 style={{textAlign: 'center'}}>Tour Information</h3>
            <p>
              <strong>Schedule:</strong> Customized to your and the guides availability
            </p>
            <p><strong>Meeting Point:</strong> At your accommodation or any agreed point</p>
            <p><strong>Price:</strong> Private rate (depends on group size)</p>

          <button
          className="book-button"
          onClick={() =>
            window.open(
              "https://wa.me/355686328765?text=Hello! I would like to book the Gjirokaster Private Tour.",
              "_blank"
            )
          }
        >
          Book This Tour
        </button>
          </div>
        </div>
      </div>

<h1 className="tour-overview-heading">Tour gallery</h1>
<div className="photo-gallery">
  {images.map((img, index) => (
    <img
      key={index}
      src={img}
      alt={`Berat ${index + 1}`}
      loading="lazy"   // <-- lazy load each image
      onClick={() => openLightbox(index)}
    />
  ))}
</div>
      {/* Lightbox with Next / Previous Buttons */}
      {lightboxOpen && (
        <div className="lightbox" onClick={() => setLightboxOpen(false)}>
          <img src={images[currentIndex]} alt={`Preview ${currentIndex}`} />
          <button className="prev-btn" onClick={prevImage}>‹</button>
          <button className="next-btn" onClick={nextImage}>›</button>
        </div>
      )}

      <div ref={bookingRef}>
        <Footer />
      </div>
    </div>
  );
}
